import { render } from "./missedOpportunities.vue?vue&type=template&id=355270e5"
import script from "./missedOpportunities.vue?vue&type=script&lang=js"
export * from "./missedOpportunities.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__